import { render } from "./DocPlatformInfo.vue?vue&type=template&id=2c9557a3&scoped=true"
import script from "./DocPlatformInfo.vue?vue&type=script&lang=js"
export * from "./DocPlatformInfo.vue?vue&type=script&lang=js"

import "./DocPlatformInfo.vue?vue&type=style&index=0&id=2c9557a3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9557a3"]])

export default __exports__